<template>
    <v-container class="pa-0">
        <v-alert
                :value="errorCheck"
                transition="scale-transition"
                icon="warning"
                color="error">
            Βάσει της νομοθεσίας δεν δικαιούστε δωρεάν διανομής συγγραμμάτων
            εφόσον είστε άνω των ν+2 ετών φοίτησης ή παρακολουθείτε μαθήματα
            για τη λήψη τρίτου ή ανωτέρου πτυχίου προπτυχιακών σπουδών.
            Έχετε τη δυνατότητα να αποκτήσετε συγγράμματα μόνο μέσω της Ανταλλαγής Συγγραμμάτων (Eudoxus+)
        </v-alert>
        <br>
        <h2 class="text-xs-center">Επιλογή Συγγραμμάτων</h2>
        <v-tabs
                color="grey lighten-3"
                light
                centered
                height="65px"
                icons-and-text>
            <v-tabs-slider color="primary"></v-tabs-slider>

            <v-tab icon="error" href="#tab-1" active-class="default-class elevation-24">
                Τμήμα Φοιτητή
                <v-icon class="secondary--text">book</v-icon>
            </v-tab>

            <v-tab href="#tab-2" active-class="default-class elevation-24">
                Διασυνδεδεμένα Τμήματα
                <v-icon class="secondary--text">location_city</v-icon>
            </v-tab>

            <v-tab-item
                    v-for="i in 2"
                    :id="'tab-' + i"
                    :key="i">
                <StudentDepartmentComponent v-if="i === 1"></StudentDepartmentComponent>
                <LinkedDepartmentsComponent v-else></LinkedDepartmentsComponent>
            </v-tab-item>
        </v-tabs>

    </v-container>
</template>

<script>

    import StudentDepartmentComponent from "./StudentDepartmentComponent";
    import LinkedDepartmentsComponent from "./LinkedDepartmentsComponent";
    import {mapGetters} from 'vuex';

    export default {
        name: "StatementBookTabsComponent",
        components: {
            LinkedDepartmentsComponent,
            StudentDepartmentComponent
        },
        data() {
            return {

            }
        },
        methods: {

        },
        computed: {
            ...mapGetters({
                errorCheck: 'errorCheck'
            })
        }
    }
</script>

<style scoped>

</style>
